(function() {
  var waves = [];
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function WaveSVG(container, canvasEl) {
    this.container = container;
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 1000 200');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('class', 'wave-divider-svg');
    var path = document.createElementNS(SVG_NS, 'path');
    svg.appendChild(path);
    canvasEl.parentNode.replaceChild(svg, canvasEl);
    this.svg = svg;
    this.path = path;
    this.color = getComputedStyle(container).color;
    path.setAttribute('fill', this.color);
    // Per-instance random phase so the 3 dividers never sync
    this.phase = Math.random() * Math.PI * 2;
    this.driftPhase = Math.random() * Math.PI * 2;
  }

  WaveSVG.prototype.update = function(t) {
    var w = 1000, h = 200;
    // Slow waves down on narrow viewports so crests don't visibly race across the screen
    var actualW = this.svg.clientWidth || 1000;
    var widthScale = Math.min(1, Math.max(0.4, actualW / 900));
    var speedMul = widthScale;
    var baseY = h * 0.58;
    var amp = h * 0.48;

    // Slow breathing (organic)
    var breathe = 1 + 0.16 * Math.sin(t * 0.00025 + this.phase);
    amp *= breathe;

    // Control points across width — few crests = lazy water look
    var N = 6;
    var pts = [];
    for (var i = 0; i <= N; i++) {
      var x = (i / N) * w;
      var seed = this.phase + i * 1.31;
      var tt = t * speedMul;
      var y = baseY
        + amp * 0.60 * Math.sin(seed * 0.85 + tt * 0.00040)
        + amp * 0.28 * Math.sin(seed * 1.90 + tt * 0.00065 + this.driftPhase)
        + amp * 0.14 * Math.sin(seed * 3.40 + tt * 0.00098);
      // Keep valleys well inside the viewBox so the container's bottom edge never shows as a flat line
      if (y > h - 6) y = h - 6;
      if (y < 4) y = 4;
      pts.push({ x: x, y: y });
    }

    // Cubic Bezier through the control points for buttery smoothness
    var d = 'M 0,' + h + ' L ' + pts[0].x.toFixed(1) + ',' + pts[0].y.toFixed(2);
    for (var i = 0; i < N; i++) {
      var p0 = pts[i], p1 = pts[i + 1];
      var cp1x = p0.x + (p1.x - p0.x) * 0.5;
      var cp1y = p0.y;
      var cp2x = p1.x - (p1.x - p0.x) * 0.5;
      var cp2y = p1.y;
      d += ' C ' + cp1x.toFixed(1) + ',' + cp1y.toFixed(2)
         + ' ' + cp2x.toFixed(1) + ',' + cp2y.toFixed(2)
         + ' ' + p1.x.toFixed(1) + ',' + p1.y.toFixed(2);
    }
    d += ' L ' + w + ',' + h + ' L 0,' + h + ' Z';
    this.path.setAttribute('d', d);
  };

  function refreshColors() {
    waves.forEach(function(w) {
      w.color = getComputedStyle(w.container).color;
      w.path.setAttribute('fill', w.color);
    });
  }

  function init() {
    // Alt look: rotating squircles
    if (window.location.search.indexOf('waves=framer') !== -1) {
      document.documentElement.classList.add('waves-framer');
      return;
    }
    var canvases = document.querySelectorAll('.wave-divider-canvas');
    if (canvases.length === 0) return;
    canvases.forEach(function(c) {
      waves.push(new WaveSVG(c.parentElement, c));
    });

    function loop(t) {
      waves.forEach(function(w) { w.update(t); });
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);

    setTimeout(refreshColors, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
